/* global Swiper */
// *******************************************************************************
// 1.0 - Landing Module
// *******************************************************************************

const landingSliderPagination = document.querySelectorAll('.landing-module__title-link');

const removeActiveClass = (element) => {
  landingSliderPagination.forEach((elm) => {
    elm.classList.remove('is-active');
  });
  element.classList.add('is-active');
};

const landingSlider = new Swiper('.swiper--landing', {
  slidesPerView: 1,
  spaceBetween: 20,
  watchOverflow: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});

landingSlider.on('slideChange', () => {
  const activeSlideIndex = landingSlider.realIndex;
  removeActiveClass(landingSliderPagination[activeSlideIndex]);
});

// **********************************************************
// Scroll To Next Section
// **********************************************************

attachEvent('.scroll-down', 'click', () => {
  // eslint-disable-next-line
  if (typeof fullpage_api === 'object') {
    // eslint-disable-next-line
    fullpage_api.moveTo(2);
  }
});
